import { useState } from 'react';

import { businessTypeEnum } from '../../constants/constants';
import useToast from '../useToast';
import { monthlyTemplateUbicationsAdapter } from '../../adapters/generateTemplate/ubicationsAdapter';
import { mapperAllArray } from '../../utils/mapper';

import {
  addPosLinesWithOutRepetition,
  filterUbication,
  getIndexUbiaction,
  updateLocationData
} from './utils';

const useLocationForWorkReportTemplate = ({ isEdit = false, accordionsSelecteds }) => {
  const [locations, setLocations] = useState([]);
  const [tipoNegocio, setTipoNegocio] = useState(null);
  const { setNewToast } = useToast();

  const isDuplicateLocation = (values) => {
    if (isEdit) {
      return locations.some(
        (loc) => loc.nombre === values?.ubication?.ubication?.nombre && !loc?.eliminarUbicacion
      );
    }

    return locations.some((loc) => loc.nombre === values?.ubication?.ubication?.nombre);
  };

  const isOneUbicationType = (values) => locations.every((loc) => loc.isOyM === values?.isOyM);

  const addNewLocation = (values) => {
    locations.push({
      id: Math.floor(Math.random() * (999999 - 100000 + 1)),
      isOyM: values?.isOyM,
      tipoUbicacionEnum: values?.ubication?.ubicationType?.id,
      nombre: values?.ubication?.ubication?.nombre,
      idOperacion: values?.isOyM ? values?.ubication?.uunn?.id : null,
      idUnidadNegocio: values?.isOyM ? null : values?.ubication?.uunn?.id,
      tienePosicionLinea: false,
      posLines: [],
      ...values
    });
  };

  const handleEditLocation = (values) => {
    const indexUbiaction = getIndexUbiaction({ ubications: locations, values });

    if (indexUbiaction === -1) {
      const [mappedLocation] = monthlyTemplateUbicationsAdapter([values]);

      locations.push({
        ...mappedLocation,
        id: Math.floor(Math.random() * (999999 - 100000 + 1)),
        isNewUbication: isEdit,
        isOyM: values?.isOyM,
        nombre: values?.ubication?.ubication?.nombre,
        tienePosicionLinea: false,
        tipoUbicacionEnum: values?.ubication?.ubicationType?.id,
        posLines: [],
        eliminarUbicacion: false
      });
    } else {
      locations[indexUbiaction].eliminarUbicacion = false;
      locations[indexUbiaction].posLines?.forEach((pL) => {
        // eslint-disable-next-line no-param-reassign
        pL.eliminarPosicionLinea = true;
      });
      setNewToast({
        type: 'SUCCESS',
        message: 'Ubicación agregada correctamente'
      });
    }
  };

  const setUbicationsAcc = (values) => {
    if (isDuplicateLocation(values)) {
      setNewToast({
        type: 'ERROR',
        message: 'Ubicación ya agregada'
      });

      return;
    }

    if (!isOneUbicationType(values)) {
      setNewToast({
        type: 'ERROR',
        message: 'No puede agregarse la ubicación, seleccione otra'
      });

      return;
    }

    if (isEdit) {
      handleEditLocation(values);
    } else {
      addNewLocation(values);
    }

    setLocations(locations);
    const tipoNegocioSelected = locations[0]?.isOyM
      ? businessTypeEnum.OYM
      : businessTypeEnum.towerServices;

    setTipoNegocio(tipoNegocioSelected);
  };

  const handleDeleteUbication = (idUbicacion) => {
    const temporal = filterUbication({
      ubications: locations,
      isEditFilter: isEdit,
      idUbicationToDelete: idUbicacion
    });

    setLocations(temporal);
    setNewToast({
      type: 'SUCCESS',
      message: 'Ubicación eliminada correctamente'
    });
  };

  const handleUpdateLocationData = ({ index, positionNumber, lineNumber, plIndex }) => {
    const locationsCopy = structuredClone(locations);

    const locationToUpdate = updateLocationData({
      ubications: locationsCopy,
      ubicationIndex: index,
      positionNumber,
      lineNumber,
      isEdit,
      plIndex
    });

    if (locationsCopy[index].posLines.length === 0) {
      locationsCopy[index].tienePosicionLinea = false;
    }

    setLocations(locationToUpdate);
  };

  const handleSubmitPosLines = (pLArray) => {
    const mappedLines = mapperAllArray(pLArray, isEdit);

    // Se comparan ids de lineas anteriores con actuales para que no se agreguen duplicados

    let duplicado = false;
    const linesIdsList = mappedLines.map((line) => line.idLinea);

    const isShared = (element) => linesIdsList.some((id) => id === element.idLinea);

    const oldPosLines = locations.map((loc) => {
      if (accordionsSelecteds?.includes(loc.id)) {
        return loc.posLines.some(isShared);
      }

      return false;
    });

    duplicado = oldPosLines.includes(true);

    if (duplicado) {
      setNewToast({
        type: 'ERROR',
        message: 'Una posición y línea es duplicada'
      });

      return;
    }

    setLocations((oldLocations) =>
      oldLocations.map((loc) => {
        if (accordionsSelecteds?.includes(loc.id)) {
          return {
            ...loc,
            posLines: addPosLinesWithOutRepetition({
              currentPosLines: loc.posLines,
              newPosLines: mappedLines
            }),
            tienePosicionLinea: true
          };
        }

        return loc;
      })
    );
    setNewToast({
      type: 'SUCCESS',
      message: 'Posición y línea agregada correctamente'
    });
  };

  return {
    locations,
    setLocations,
    tipoNegocio,
    setUbicationsAcc,
    handleDeleteUbication,
    handleUpdateLocationData,
    handleSubmitPosLines
  };
};

export default useLocationForWorkReportTemplate;
